import { render, staticRenderFns } from "./mrRadio.vue?vue&type=template&id=5c47c60a&scoped=true&lang=pug&"
import script from "./mrRadio.vue?vue&type=script&lang=js&"
export * from "./mrRadio.vue?vue&type=script&lang=js&"
import style0 from "./mrRadio.vue?vue&type=style&index=0&id=5c47c60a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c47c60a",
  null
  
)

export default component.exports